import { approvalTemplateService } from '@/services/approvalTemplateService';
import { notifyService } from '@/services/notifyService';
import { useUserStore } from '@/stores/user';
import type { ApprovalTemplate, Approver } from '@/types/approvalTemplate';
import { defineStore } from 'pinia';

interface State {
  approverEmployeeIds: Set<number>; // 所有模板中的审批人 employeeId 集合
}

export const useApprovalStore = defineStore('approval', {
  state: (): State => ({
    approverEmployeeIds: new Set<number>(),
  }),
  actions: {
    // 加载所有模板的审批人并缓存 employeeId 集合
    async loadAllApprovers() {
      try {
        const templates: ApprovalTemplate[] = await approvalTemplateService.list();
        const ids = new Set<number>();
        templates.forEach((tpl: ApprovalTemplate) => {
          // 仅统计启用状态模板的审批人
          if (tpl.status === 'ACTIVE') {
            tpl.approvers
              .filter((a: Approver) => a.status === 'ACTIVE')
              .forEach((a: Approver) => {
                if (typeof a.employeeId === 'number' && a.employeeId > 0) ids.add(a.employeeId);
              });
          }
        });
        this.approverEmployeeIds = ids;
        return ids;
      } catch (e) {
        notifyService.error((e as Error).message);
        throw e;
      }
    },
    // 判断当前用户是否为任一模板的审批人
    isCurrentUserApprover(): boolean {
      const user = useUserStore();
      const eid = user.employeeId;
      if (eid == null) return false;
      return this.approverEmployeeIds.has(eid);
    },
  },
});
